import request from '@/utils/request';
/* 列表 */
export function goodsList(data) {
  return request({
    url: '/goods/queryGoodsPageList',
    method: 'POST',
    data
  });
}
/* 回收站列表 */
export function queryRecycleGoodsPageList(data) {
  return request({
    url: '/goods/queryRecycleGoodsPageList',
    method: 'POST',
    data
  });
}
/* 回收站列表-恢复 */
export function restoreGoods(data) {
  return request({
    url: '/goods/restoreGoods',
    method: 'POST',
    data
  });
}
/* 删除商品操作 */
export function removeGoodsById(data) {
  return request({
    url: '/goods/removeGoodsById',
    method: 'POST',
    data
  });
}
/* 搜索中的分类数据 */
export function searchCateInfo(data) {
  return request({
    url: '/goods/queryGoodsCategoryTreeList',
    method: 'POST',
    data
  });
}
/* 批量上下架操作 status是否上架0-待上架1-已上架 */
export function enableGoodsStatus(data) {
  return request({
    url: '/goods/enableGoodsStatus',
    method: 'POST',
    data
  });
}
/* 同步数据操作 */
export function syncGoodsSpecData(data) {
  return request({
    url: '/goods/syncGoodsSpecData',
    method: 'POST',
    data
  });
}
/* 商品详情 */
export function goodsDetail(data) {
  return request({
    url: '/goods/fetchWebGoodsDetailById',
    method: 'POST',
    data
  });
}
/* 商品标签 */
export function queryAllGoodsLabelList(data) {
  return request({
    url: '/goods/queryAllGoodsLabelList',
    method: 'POST',
    data
  });
}
/* 运费模版 */
export function queryAllGoodsMoveTemplateList(data) {
  return request({
    url: '/goods/move/template/queryAllGoodsMoveTemplateList',
    method: 'POST',
    data
  });
}
/* 获取省市区三级联动数据 */
export function queryAreaTreeList(data) {
  return request({
    url: '/wechat/minApp/goods/queryAreaTreeList',
    method: 'POST',
    data
  });
}
/* 添加运费模版 */
export function saveGoodsMoveTemplate(data) {
  return request({
    url: '/goods/move/template/saveGoodsMoveTemplate',
    method: 'POST',
    data
  });
}
/* 修改商品信息 */
export function updateWebGoods(data) {
  return request({
    url: '/goods/updateWebGoods',
    method: 'POST',
    data
  });
}
/* 自提点数据 */
export function queryWebPickupAddressList(data) {
  return request({
    url: '/pickup/address/queryWebPickupAddressList',
    method: 'POST',
    data
  });
}
/* 获取商品信息列表出售中、仓库中总数据 */
export function queryWebGoodsCount(data) {
  return request({
    url: '/goods/queryWebGoodsCount',
    method: 'POST',
    data
  });
}
/* 新增或修改经营资质 */
export function saveOrUpdateBusinessQualificationConfig(data) {
  return request({
    url: '/config/saveOrUpdateBusinessQualificationConfig',
    method: 'POST',
    data
  });
}
/* 获取经营资质数据 */
export function fetchBusinessQualificationConfigDetail(data) {
  return request({
    url: '/config/fetchBusinessQualificationConfigDetail',
    method: 'POST',
    data
  });
}
/* 服务说明-列表 */
export function queryServiceDescPageList(data) {
  return request({
    url: '/service/desc/queryServiceDescPageList',
    method: 'POST',
    data
  });
}
/* 服务说明-新增 */
export function saveServiceDesc(data) {
  return request({
    url: '/service/desc/saveServiceDesc',
    method: 'POST',
    data
  });
}
/* 服务说明-修改 */
export function updateServiceDesc(data) {
  return request({
    url: '/service/desc/updateServiceDesc',
    method: 'POST',
    data
  });
}
/* 服务说明-明细 */
export function fetchServiceDescDetailById(data) {
  return request({
    url: '/service/desc/fetchServiceDescDetailById',
    method: 'POST',
    data
  });
}
/* 服务说明-删除 */
export function removeServiceDescById(data) {
  return request({
    url: '/service/desc/removeServiceDescById',
    method: 'POST',
    data
  });
}
/* 服务说明-启用或关闭 */
export function enableServiceDescById(data) {
  return request({
    url: '/service/desc/enableServiceDescById',
    method: 'POST',
    data
  });
}
/* 服务说明-获取所有已开启的服务说明 */
export function queryAllEnableServiceDescList(data) {
  return request({
    url: '/service/desc/queryAllEnableServiceDescList',
    method: 'POST',
    data
  });
}
/* 服务说明-绑定商品 */
export function saveOrUpdateServiceGoodsBind(data) {
  return request({
    url: '/service/desc/saveOrUpdateServiceGoodsBind',
    method: 'POST',
    data
  });
}
/* 推荐商品-推荐商品列表 */
export function queryGoodsRelatedPageList(data) {
  return request({
    url: '/goods/related/queryGoodsRelatedPageList',
    method: 'POST',
    data
  });
}
/* 推荐商品-新增 */
export function saveGoodsRelated(data) {
  return request({
    url: '/goods/related/saveGoodsRelated',
    method: 'POST',
    data
  });
}
/* 推荐商品-删除操作 */
export function removeGoodsRelatedById(data) {
  return request({
    url: '/goods/related/removeGoodsRelatedById',
    method: 'POST',
    data
  });
}
/* 推荐商品-获取所有已上架的商品 */
export function queryAllEnableGoodsList(data) {
  return request({
    url: '/goods/related/queryAllEnableGoodsList',
    method: 'POST',
    data
  });
}
/* 获取平台商品列表 */
export function queryPlatformGoodsPageList(data) {
  return request({
    url: '/goods/queryPlatformGoodsPageList',
    method: 'POST',
    data
  });
}
/* 获取平台商品列表-获取平台商品规格列表 */
export function queryPlatformGoodsSpecPageList(data) {
  return request({
    url: '/goods/spec/queryPlatformGoodsSpecPageList',
    method: 'POST',
    data
  });
}
/* 获取门店商品分页列表 */
export function queryShopGoodsPageList(data) {
  return request({
    url: '/shop/goods/queryShopGoodsPageList',
    method: 'POST',
    data
  });
}
/* 获取门店商品分页列表-新增门店商品 */
export function saveShopGoods(data) {
  return request({
    url: '/shop/goods/saveShopGoods',
    method: 'POST',
    data
  });
}
/* 获取门店商品分页列表-修改门店商品 */
export function updateShopGoods(data) {
  return request({
    url: '/shop/goods/updateShopGoods',
    method: 'POST',
    data
  });
}
/* 获取门店商品分页列表-获取门店商品明细 */
export function fetchShopGoodsDetailById(data) {
  return request({
    url: '/shop/goods/fetchShopGoodsDetailById',
    method: 'POST',
    data
  });
}
/* 获取门店商品分页列表-删除门店商品 */
export function removeShopGoodsById(data) {
  return request({
    url: '/shop/goods/removeShopGoodsById',
    method: 'POST',
    data
  });
}
/* 获取门店商品分页列表-更新门店商品状态 */
export function updateShopGoodsStatus(data) {
  return request({
    url: '/shop/goods/updateShopGoodsStatus',
    method: 'POST',
    data
  });
}
/* 获取门店商品分页列表-获取可选择商品 */
export function shopQueryAllEnableGoodsList(data) {
  return request({
    url: '/shop/goods/queryAllEnableGoodsList',
    method: 'POST',
    data
  });
}
/* 获取门店商品分页列表-更新门店商品是否展示在首页 */
export function updateShopGoodsShowHome(data) {
  return request({
    url: '/shop/goods/updateShopGoodsShowHome',
    method: 'POST',
    data
  });
}
/* 获取门店商品分页列表-批量上下架商品 */
export function batchUpdateGoodsStatus(data) {
  return request({
    url: '/shop/goods/batchUpdateGoodsStatus',
    method: 'POST',
    data
  });
}

/* 商品检测报告 */
export function queryGoodsInspectionReportPageList(data) {
  return request({
    url: '/goods/inspection/report/queryGoodsInspectionReportPageList',
    method: 'POST',
    data
  });
}
export function fetchGoodsInspectionReportDetailById(data) {
  return request({
    url: '/goods/inspection/report/fetchGoodsInspectionReportDetailById',
    method: 'POST',
    data
  });
}
export function saveGoodsInspectionReport(data) {
  return request({
    url: '/goods/inspection/report/saveGoodsInspectionReport',
    method: 'POST',
    data
  });
}
export function updateGoodsInspectionReport(data) {
  return request({
    url: '/goods/inspection/report/updateGoodsInspectionReport',
    method: 'POST',
    data
  });
}
export function removeGoodsInspectionReportById(data) {
  return request({
    url: '/goods/inspection/report/removeGoodsInspectionReportById',
    method: 'POST',
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/goods.js